import type { UseQueryResult } from '@tanstack/react-query';

/**
 * Данные запроса получены: ответ пришёл хотя бы раз, даже если последнее перечитывание отказало.
 *
 * Окончание загрузки этого не означает: запрос, отклонённый с первого раза, загрузку закончил, а данных
 * не дал (повторов нет — `retry: 0`), и вывод «в списке такого нет» на нём ложен. Отказ перечитывания
 * оставляет прежние данные — выводы на них по-прежнему верны.
 */
export const isQueryDataReceived = (query: Pick<UseQueryResult, 'isSuccess' | 'isRefetchError'>): boolean =>
  query.isSuccess || query.isRefetchError;
